var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7229_59864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.49994C16 9.02755 15.2404 9.47127 15.1386 9.96883C15.0368 10.4664 15.5645 11.1568 15.3712 11.614C15.1778 12.0712 14.3171 12.167 14.0425 12.5737C13.7678 12.9803 14.0027 13.811 13.6569 14.1568C13.3111 14.5026 12.4804 14.2676 12.0738 14.5424C11.6672 14.817 11.5714 15.6778 11.1141 15.8711C10.6569 16.0645 9.96651 15.5367 9.46895 15.6384C8.97139 15.7402 8.52767 16.4999 8.00006 16.4999C7.47245 16.4999 7.02873 15.7403 6.53117 15.6384C6.03361 15.5367 5.3432 16.0644 4.88602 15.8711C4.42884 15.6777 4.33299 14.817 3.92629 14.5424C3.5197 14.2677 2.689 14.5026 2.34322 14.1568C1.99743 13.811 2.2324 12.9803 1.95763 12.5737C1.68298 12.1671 0.822227 12.0713 0.628912 11.614C0.435597 11.1567 0.963326 10.4664 0.861563 9.96883C0.759567 9.47127 0 9.02767 0 8.49994C0 7.97221 0.759567 7.52861 0.861446 7.03105C0.96321 6.53349 0.435481 5.84308 0.628796 5.3859C0.822227 4.92872 1.68286 4.83288 1.95752 4.42617C2.23217 4.01958 1.99732 3.18889 2.3431 2.8431C2.68889 2.49732 3.51958 2.73229 3.92617 2.45752C4.33276 2.18286 4.42861 1.32211 4.8859 1.1288C5.34308 0.935365 6.03349 1.46321 6.53105 1.36145C7.02861 1.25957 7.47233 0.5 7.99994 0.5C8.52755 0.5 8.97127 1.25957 9.46883 1.36145C9.96639 1.46321 10.6568 0.935481 11.114 1.1288C11.5712 1.32223 11.667 2.18286 12.0737 2.45752C12.4803 2.73217 13.311 2.49732 13.6568 2.8431C14.0026 3.18889 13.7676 4.01958 14.0424 4.42617C14.317 4.83276 15.1778 4.92861 15.3711 5.3859C15.5645 5.84308 15.0367 6.53349 15.1384 7.03105C15.2402 7.52861 15.9999 7.97233 15.9999 8.49994H16Z",
    fill: "url(#paint0_linear_7229_59864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6794 5.47032L11.8049 4.59598C11.677 4.46801 11.4695 4.46801 11.3415 4.59598L6.87614 9.06158L4.9338 7.11924C4.80583 6.99126 4.59839 6.99126 4.47042 7.11924L3.59598 7.99357C3.46801 8.12155 3.46801 8.32898 3.59598 8.45696L6.6445 11.5056C6.77248 11.6336 6.97991 11.6336 7.10789 11.5056L12.6795 5.9338C12.8074 5.80583 12.8073 5.59819 12.6794 5.47032Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7229_59864",
    x1: 2.3431,
    y1: 14.1568,
    x2: 13.6568,
    y2: 2.8431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008CFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7229_59864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.9999,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verifiedIcon.f3872346cab4d3fd13dd2bdba5b76c69.svg";
export { ForwardRef as ReactComponent };